import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static250};
  height: 100%;

  @media (min-width: ${Breakpoints.b1280}px) {
    gap: ${({ theme }) => theme.size.static350};
  }
`;

export const StyledMaintenanceType = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static200};
  height: 100%;
  justify-content: flex-start;

  hr {
    width: 100%;
  }
`;

export const StyledContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

export const StyledMaintenanceTypeTitle = styled.div`
  ${({ theme, viewCompleteSchedule }) => {
    return `
      align-items: center;
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      justify-content: center;
      padding: ${theme.size.static350};

      ${
        viewCompleteSchedule &&
        `
          max-height: 100px;
        `
      } 
        
      @media (min-width: ${Breakpoints.b1280}px) {
        padding: ${theme.size.static150} ${theme.size.static400};
      }

      > p {
        color: ${theme.colors.content.primary};
        text-align: center;
      }

      > p + p {
        color: ${theme.colors.content.tertiary};
      }
    `;
  }}
`;

export const StyledInformation = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static100};
      padding: ${theme.size.static350};

      p{
        color: ${theme.colors.content.primary};
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        padding: ${theme.size.static350} ${theme.size.static400};
      }
    `;
  }}
`;

export const StyledInformationTitle = styled.div`
  display: flex;
  gap: 6px;
  align-self: stretch;

  > p {
    margin: 0;
  }
`;

export const StyledInformationDescription = styled.div`
  p {
    color: ${({ theme }) => theme.colors.content.secondary};
  }
`;

export const StyledViewAllCTA = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  height: 60px;
  justify-content: center;
  margin-top: auto;
  padding: ${({ theme }) => theme.size.static350} 0;
`;

export const StyledErrorAPIContent = styled.div<{ theme }>`
  display: flex;
  padding: 0 24px;
  padding-bottom: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const StyledErrorAPITitle = styled.div<{ theme }>`
  display: flex;
  padding: 8px;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;

  border-radius: 4px;
  background: rgba(228, 0, 44, 0.04);
`;

export const StyledAlertWrapper = styled.div<{ theme }>`
  svg {
    color: ${({ theme }) => theme.colors.signal.error || '#e4002c'};
  }
`;
